var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7018 22.7376L34.4387 12.8H32.3686L24.7789 21.4269L18.7215 12.8H11.7333L20.8954 25.8465L11.7333 36.2667H13.8034L21.8134 27.1543L28.2118 36.2667H35.1999L25.7018 22.7376ZM22.8656 25.9611L21.9358 24.6611L14.5499 14.3271H17.73L23.6924 22.6701L24.6182 23.97L32.3676 34.8141H29.1875L22.8656 25.9611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.10ae6c767be0a17876f442ed13c2f07f.svg";
export { ForwardRef as ReactComponent };